import { render } from "./SaveCustomField.vue?vue&type=template&id=30bb16ec&scoped=true"
import script from "./SaveCustomField.vue?vue&type=script&lang=js"
export * from "./SaveCustomField.vue?vue&type=script&lang=js"

import "./customField.scss?vue&type=style&index=0&id=30bb16ec&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bb16ec"]])

export default __exports__